import pushClevertapEvent from 'clevertap/pushClevertapEvent';

import formatDate from 'clevertap/formatDate';

function mapHistoryDetailToClevertap(d) {
  return {
    'Item Name': d.item_name,
    Variant: d.item_variant_name,
    'Qty in Stock': d.beginning_stock,
    'Qty Order': d.quantity,
    'Unit Cost': d.price,
    'Total Cost': d.quantity * d.price,
  };
}

function mapIngredientHistoryDetailToClevertap(d) {
  return {
    'Ingredient Name': d.ingredient_name,
    'Qty in Stock': d.beginning_stock,
    'Qty Order': d.quantity,
    'Unit Cost': d.unit_price,
    'Total Cost': d.quantity * d.unit_price,
  };
}

export function inventoryPOStart({ outletIds, startDate, endDate, namespace }) {
  pushClevertapEvent('Inventory PO Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
    'Current Inventory Filter': namespace,
  });
}

export function inventoryPOCreate({
  fulfilled,
  supplier,
  outlet,
  namespace,
  items,
}) {
  const data = {
    'Current Inventory Filter': namespace,
    'Outlet Name': outlet.name,
    'Supplier Name': supplier.name,
  };
  if (namespace === 'items') {
    data['List of Items'] = items.map(d => ({
      'Ingredient Name': d.item_name,
      'Qty in Stock': d.instock,
      'Qty Order': d.order,
      'Unit Cost': d.unitcost,
      'Total Cost': d.order * d.unitcost,
    }));
  } else {
    data['List of Ingredients'] = items.map(d => ({
      'Item Name': d.item_name,
      Variant: d.item_var_name,
      'Qty in Stock': d.instock,
      'Qty Order': d.order,
      'Unit Cost': d.unitcost,
      'Total Cost': d.order * d.unitcost,
    }));
  }
  if (fulfilled) {
    pushClevertapEvent('Inventory PO Create and Fulfill', data);
  } else {
    pushClevertapEvent('Inventory PO Create', data);
  }
}

export function inventoryPOSelect({ purchaseOrder }) {
  const namespace = purchaseOrder.hasOwnProperty('history_details')
    ? 'items'
    : 'ingredients';
  const clevertapData = {
    'Supplier Name': purchaseOrder.supplier_name,
    'Supplier Email': purchaseOrder.supplier_email,
    'Supplier Phone': purchaseOrder.supplier_phone,
    'PO Number': purchaseOrder.order_no,
    'PO Created At': formatDate(purchaseOrder.created_at),
    'PO Created By': `${purchaseOrder.creator.first_name} ${purchaseOrder.creator.last_name}`,
    Email: purchaseOrder.creator.email,
    'Outlet Name': purchaseOrder.outlet.name,
    Phone: purchaseOrder.outlet.phone_number,
    Address: purchaseOrder.outlet.address,
  };
  if (namespace === 'items') {
    clevertapData['List of Items'] = purchaseOrder.history_details.map(
      mapHistoryDetailToClevertap
    );
  } else {
    clevertapData[
      'List of Ingredients'
    ] = purchaseOrder.ingredient_history_details.map(
      mapIngredientHistoryDetailToClevertap
    );
  }
  pushClevertapEvent('Inventory Select PO', clevertapData);
}

export function inventoryPOUpdateStatus({ purchaseOrder, status }) {
  const namespace = purchaseOrder.hasOwnProperty('history_details')
    ? 'items'
    : 'ingredients';
  const clevertapData = {
    'Outlet Name': purchaseOrder.outlet.name,
    'Supplier Name': purchaseOrder.supplier_name,
    'Current Inventory Filter': namespace,
  };
  let eventName;
  if (status === 'Fulfilled') {
    eventName = 'Inventory PO Mark Fulfilled';
  } else if (status === 'Cancelled') {
    eventName = 'Inventory PO Cancel Order';
  }
  if (namespace === 'items') {
    clevertapData['List of Items'] = purchaseOrder.history_details.map(
      mapHistoryDetailToClevertap
    );
  } else {
    clevertapData[
      'List of Ingredients'
    ] = purchaseOrder.ingredient_history_details.map(
      mapIngredientHistoryDetailToClevertap
    );
  }

  // if eventname is null, do not track
  if (eventName) {
    pushClevertapEvent(eventName, clevertapData);
  }
}

export function inventoryPOExport({
  outletIds,
  startDate,
  endDate,
  namespace,
}) {
  pushClevertapEvent('Inventory PO Export', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
    'Current Inventory Filter': namespace,
  });
}

export function inventoryPOImport({ outletIds, namespace, business, outlets }) {
  let outletname;
  if (outletIds.length > 1) {
    outletname = 'All Outlet';
  } else {
    outletname = outlets.reduce(function(filtered, outlet) {
      if (outlet.id === outletIds[0]) {
        filtered.push(outlet.name);
      }
      return filtered;
    }, []);
  }
  pushClevertapEvent('Inventory PO Import Start', {
    'Business Id': business.id,
    'Current Selected Outlet': outletIds,
    'Current Inventory Filter': namespace,
    'Outlet Name': outletIds.length > 1 ? outletname : outletname[0],
  });
}

export function inventoryPOImportSuccess({ outletIds }) {
  pushClevertapEvent('Inventory PO Import Success', {
    'Outlet Id': outletIds,
  });
}

export function inventoryPOImportFailed({ outletIds }) {
  pushClevertapEvent('Inventory PO Import Failed', {
    'Outlet Id': outletIds,
  });
}
